<template>
  <div v-if="recollects.length > 0">
    <dispense-modal :id="idSelect" />
    <div
      v-for="(recollect, recollectIndex) in recollects"
      :key="recollectIndex"
      class="data-table__body__row"
    >
      <data-cell :size="10">
        <h4 class="text-color-tundora overflow-text">
          <span class="reason">{{ formatDate(recollect.createdAt) }}</span>
        </h4>
        <p class="sub">às {{ formatHour(recollect.createdAt) }}</p>
      </data-cell>

      <data-cell :size="10">
        <h4 class="text-color-tundora">
          <span class="reason">{{ recollect?.orderId ? recollect.orderId : '-' }}</span>
        </h4>
        <p class="sub">
          {{ recollect?.code_lis ? recollect?.code_lis : '-' }}
        </p>
      </data-cell>

      <data-cell :size="20">
        <h4 class="text-color-tundora">
          <span>{{ recollect.patient.name }}</span>
        </h4>
      </data-cell>

      <data-cell :size="10">
        <h4 class="text-color-tundora">
          <span
            v-for="(exam, index) in examsLimited(recollect.exams)"
            :key="index"
          >
            {{ exam.mnemonic }}
            <span v-if="index + 1 < examsLimited(recollect.exams).length">,</span>
          </span>
          <span v-if="recollect.exams.length > 3">
            e + {{ recollect.exams.length - 3 }} exames
          </span>

          <md-tooltip>
            <span
              v-for="(exam, index) in recollect.exams"
              :key="index"
            >
              {{ exam.mnemonic }}
              <span v-if="index + 1 < recollect.exams.length">,</span>
            </span>
          </md-tooltip>
        </h4>
      </data-cell>

      <data-cell :size="15">
        <h4 class="text-color-tundora overflow-text">
          <span class="reason">{{ recollect.reason }}</span>
          <md-tooltip>
            <span>{{ recollect.reason }}</span>
          </md-tooltip>
        </h4>
      </data-cell>

      <data-cell :size="10">
        <p
          :class="{
            'status-orange': recollect.status === RECOLLECT_PENDING_STATUS,
            'status-green': recollect.status === RECOLLECT_RESOLVED_STATUS,
            'status-gray':
              recollect.status === RECOLLECT_DISPENSED_NEW_OS_STATUS ||
              recollect.status === RECOLLECT_DISPENSED_STATUS,
          }"
        >
          <strong
            v-if="
              recollect.status === RECOLLECT_DISPENSED_NEW_OS_STATUS ||
              recollect.status === RECOLLECT_DISPENSED_STATUS
            "
          >
            DISPENSADO
          </strong>
          <strong v-else>{{ recollect.status }}</strong>
        </p>
      </data-cell>

      <data-cell :size="10">
        <div>
          <div v-if="recollect.dispensedAt">
            <h4 class="text-color-tundora overflow-text">
              <span class="reason">{{ formatDate(recollect.dispensedAt) }}</span>
            </h4>
            <p class="sub">às {{ formatHour(recollect.dispensedAt) }}</p>
          </div>
          <div v-else-if="recollect.accomplishedAt">
            <h4 class="text-color-tundora overflow-text">
              <span class="reason">{{ formatDate(recollect.accomplishedAt) }}</span>
            </h4>
            <p class="sub">às {{ formatHour(recollect.accomplishedAt) }}</p>
          </div>
        </div>
      </data-cell>

      <data-cell
        v-if="recollect.status === RECOLLECT_RESOLVED_STATUS"
        :size="15"
      >
        <div
          v-if="
            recollect.status === RECOLLECT_RESOLVED_STATUS ||
            recollect.status === RECOLLECT_PENDING_STATUS
          "
          class="button-container"
        >
          <button
            class="sample-btn"
            :class="{ 'only-collect': recollect.status === RECOLLECT_RESOLVED_STATUS }"
            @click="
              action({
                action: status[recollect.status].action,
                requestId: recollect.requestId,
              })
            "
          >
            <svg-loader
              src="/static/images/icon-tube.svg"
              closs="icon-tube"
            />
            <md-tooltip>Ver Amostra</md-tooltip>
          </button>
        </div>
      </data-cell>

      <data-cell
        v-else-if="recollect.status === RECOLLECT_PENDING_STATUS"
        :size="15"
      >
        <div
          v-if="recollect.status === RECOLLECT_PENDING_STATUS"
          class="button-container"
        >
          <button
            class="recollect-btn mr-4"
            @click="
              action({
                action: status[recollect.status].action,
                requestId: recollect.requestId,
              })
            "
          >
            <md-tooltip
              md-delay="400"
              md-direction="bottom"
            >
              <span v-if="recollect.status === RECOLLECT_PENDING_STATUS">Recoletar</span>
              <span v-else>{{ recollect.status }}</span>
            </md-tooltip>
            <md-icon md-src="/static/images/file-document-refresh.svg" />
          </button>

          <button
            v-if="recollect.status === RECOLLECT_PENDING_STATUS"
            class="recollect-btn outline"
            @click="openDispenseModal(recollect.requestId)"
          >
            <md-tooltip
              md-delay="400"
              md-direction="bottom"
            >
              Dispensar
            </md-tooltip>
            <md-icon md-src="/static/images/file-document-remove.svg" />
          </button>
        </div>
      </data-cell>
    </div>
  </div>
</template>

<script>
import DataTable from '../common/dataTable/DataTable'
import DataCell from '../common/dataTable/DataCell'
import DataShowOff from '../common/dataTable/DataShowOff'
import DispenseModal from './DispenseModal.vue'
import strings from '@/strings'
import {
  RECOLLECT_PENDING_STATUS,
  RECOLLECT_RESOLVED_STATUS,
  RECOLLECT_DISPENSED_NEW_OS_STATUS,
  RECOLLECT_DISPENSED_STATUS,
  ORDER_SEARCH_BY_RECOLLECT,
} from '@/enums'
import { mapActions } from 'vuex'

export default {
  name: 'RecollectRow',
  components: {
    'data-table': DataTable,
    'data-cell': DataCell,
    'data-showoff': DataShowOff,
    'dispense-modal': DispenseModal,
  },
  props: {
    recollects: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      status: strings.recollectStatus,
      RECOLLECT_PENDING_STATUS: RECOLLECT_PENDING_STATUS,
      RECOLLECT_RESOLVED_STATUS: RECOLLECT_RESOLVED_STATUS,
      RECOLLECT_DISPENSED_NEW_OS_STATUS: RECOLLECT_DISPENSED_NEW_OS_STATUS,
      RECOLLECT_DISPENSED_STATUS: RECOLLECT_DISPENSED_STATUS,
      idSelect: '',
    }
  },
  methods: {
    ...mapActions(['expandRecollectDetails', 'clearAllNewOrderData', 'clearExamList']),
    action({ action, requestId }) {
      switch (action) {
        case 'createNewOrder':
          this.clearExamList()
          this.clearAllNewOrderData()
          this.$router.push('/orders/recollect/' + requestId)
          break
        case 'showOrder':
          this.$router.push({
            path: '/orders',
            query: { q: requestId, findTypeOrderResultFilter: ORDER_SEARCH_BY_RECOLLECT },
          })
          break
        case 'showSample':
          this.$router.push({
            path: '/print-tag/samples',
            query: { processingOrigin: 'RECOLLECT', idRecollect: requestId },
          })
          break
      }
    },
    examsLimited: function (exams) {
      return exams.length > 3 ? exams.slice(0, 3) : exams
    },
    openDispenseModal(id) {
      this.idSelect = id
      this.$children[0].$refs.dispenseModal.open(id)
    },
    formatDate(date) {
      return date ? new Date(date).toLocaleDateString('pt-BR') : ''
    },
    formatHour(date) {
      return date
        ? new Date(date).toLocaleTimeString('pt-BR', {
            hour: '2-digit',
            minute: '2-digit',
          })
        : ''
    },
  },
}
</script>
<style lang="scss" scoped>
.button-container {
  justify-content: flex-start;
  display: flex;

  .recollect-btn {
    background-color: #7f1a54;
    height: 40px;
    padding: 0 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    font-size: 11px;
    font-family: 'Exo 2', sans-serif;
    font-weight: 600;
    border-radius: 8px;
    width: 20px;

    &.outline {
      background-color: transparent;
      border: 2px solid #7f1a54;
      color: #7f1a54;

      :deep(i svg path) {
        fill: #7f1a54;
      }
    }
  }

  .sample-btn {
    background-color: #7f1a54;
    height: 40px;
    padding: 0 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    font-size: 11px;
    font-family: 'Exo 2', sans-serif;
    font-weight: 600;
    border-radius: 4px;
    width: 24px !important;

    &.outline {
      background-color: transparent;
      border: 2px solid #7f1a54;
      color: #7f1a54;
      margin-right: 10px;
      width: 91px;
      padding: 0 30px;
    }
  }
}

.icon-tube {
  margin-right: 10px;
}

.only-collect {
  justify-content: flex-end;
  padding: 0 24px !important;
  width: 147px !important;
}
</style>
